<template>
  <div class="slideOptions-page">
    <div class="slideOptions-page" v-if="srollX">
      <scroll-view class="slide-scroll_x">
        <div v-for="(item, index) in list" :key="index" class="slide-scroll_head_1" style="padding: 0 0.3rem;" :id="'head_' + (index + 1)">
          <div
            @click="headtap(index)"
            :class="['slide-head', tabindex == index ? 'head_1' : '']"
            :style="'color:' + (tabindex == index ? color : '#000') + ';font-size:' + size + ';'"
          >
            {{ item.title.length > 5 ? item.title.substring(0,5) : item.title }}
          </div>
          <div :style="'width:' + translateXWidth != 0 ? translateXWidth + 'px' : '100%' + ';left: 0;'" class="slide">
            <div
              :class="['slide-head_2', index != 0 ? 'hide' : '']"
              :style="'height: ' + height + ';transform:translateX(' + translateX + 'px);background-color: ' + color + ';width: ' + width + ';'"
            ></div>
          </div>
        </div>
      </scroll-view>
    </div>
    <div class="slideOptions-page" v-else>
      <div scroll-x="true" class="slide-scroll_x">
        <div v-for="(item, index) in list" :key="index" class="slide-scroll_head_1" :style="'width: ' + width + ';'" :id="'head_' + (index + 1)">
          <div
            @click="headtap(index)"
            :class="['slide-head', tabindex == index ? 'head_1' : '']"
            :style="'color:' + (tabindex == index ? color : '#000') + ';font-size:' + size + ';'"
          >
            {{ item.title.length > 5 ? item.title.substring(0,5) : item.title }}
          </div>
          <div :style="'width:' + translateXWidth != 0 ? translateXWidth + 'px' : '100%' + ';left: 0;'" class="slide" v-if="index == 0">
            <div
              :class="['slide-head_2', index != 0 ? 'hide' : '']"
              :style="'height: ' + height + ';transform:translateX(' + translateX + 'px);background-color: ' + color + ';width: ' + width + ';'"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: '0.9rem',
    },
    height: {
      type: String,
      default: '0.2rem',
    },
    tabindex: {
      type: Number,
      default: 0,
    },
    head: {
      type: Array,
    },
    list: {
      type: Array,
    },
    color: {
      type: String,
      default: '#FF2150',
    },
    width: {
      type: String,
      default: '100%',
    },
    srollX: {
      type: Boolean,
    },
  },
  data() {
    return {
      translateX: 0,
      translateXWidth: 0,
    };
  },
  methods: {
    headtap(current) {
      this.$emit('headtap', current);
      this.effect(current + 1);
    },
    effect(current) {
      const _this = this;
      let translateX = 0;
      for (let index = 0; index < current; index++) {
        if (index != 0) {
          translateX += document.getElementById(`head_${index + 1}`).offsetWidth;
          if (index + 1 == current) {
            _this.translateX = translateX;
          }
        } else if (current == 1) {
          _this.translateX = 0;
        }
      }
    },
  },
};
</script>

<style lang="less">
.slideOptions-page {
  width: 100%;
  height: 10vw;
  display: flex;
  flex-wrap: nowrap;
  transition: 0.5s;

  .slide-scroll_x {
    width: 100%;
    height: 100%;
    display: flex;
    white-space: nowrap;
    position: relative;
  }

  .slide-scroll_head_1 {
    display: inline-block;
    position: relative;
  }

  .slide-scroll_head_2 {
    display: inline-block;
    position: absolute;
    left: 0;
  }

  .slide-head_div {
    flex: 1;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    position: relative;
  }

  .slide-head {
    width: 100%;
    padding: 1.5vw 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .slide {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .slide-head_1 {
    font-weight: 700;
  }

  .slide-head_2 {
    width: 100%;
    transition: 0.5s;
  }

  .head_1 {
    font-weight: 900;
  }

  .hide {
    visibility: hidden;
  }
}
</style>
